import withDropdownHOC, { type WithDropdownCmpProps, type WithDropdownToggleProps } from "@client/hocs/withDropdown";
import withIsVisibleHOC, { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import AdminLogin from "@client/widgets/AdminLogin/container";
import Login from "@client/widgets/Login/container";
import User from "@client/widgets/User/container";
import React from "react";
import { Transition } from "react-transition-group";
import HeaderElement from "../Element/container";
import { alignContent } from "./lib";

export const INVISIBLE_PROPS: HeaderLoginProps & WithIsVisibleHOCProps = {
  isAdminLoginVisible: false,
  isLoginVisible: false,
  isUserVisible: false,
  isVisible: false
};

export interface HeaderLoginProps {
  isAdminLoginVisible: boolean;
  isLoginVisible: boolean;
  isUserVisible: boolean;
}

const HeaderLoginToggle = React.memo((props: WithDropdownToggleProps) => (
  <HeaderElement ref={props.toggleRef} onMouseEnter={props.open} onMouseLeave={props.close}>
    <i className="far fa-lock" />
  </HeaderElement>
));

const duration = 300;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0
};

const transitionStyles = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 }
};
const HeaderLoginContent = (props: WithDropdownCmpProps & HeaderLoginProps) => {
  const ref = React.createRef<HTMLDivElement>();

  return (
    <Transition nodeRef={ref} in={props.isOpen} timeout={duration}>
      {(state) => (
        <div
          // add dropdown_container to apply text styles
          ref={ref}
          className={"login_dropdown"}
          style={{
            ...defaultStyle,
            ...transitionStyles[state]
          }}
        >
          {props.isLoginVisible && <Login />}
          {props.isUserVisible && <User />}
          {props.isAdminLoginVisible && <AdminLogin />}
        </div>
      )}
    </Transition>
  );
};

const HeaderLoginDropdown = withDropdownHOC<HeaderLoginProps>(HeaderLoginToggle, HeaderLoginContent);

const HeaderLoginBase = React.memo((props: HeaderLoginProps) => (
  <HeaderLoginDropdown
    {...props}
    align={alignContent}
    dropdownClassName="login_dropdown_container"
    isAnimateable
    keepOpenIfMouseOver
    zIndex={9998}
  />
));

const HeaderLogin = withIsVisibleHOC(HeaderLoginBase);
export default HeaderLogin;
